<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/">Экспертиза промышленной безопасности</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez/">Проведение экспертизы промышленной безопасности
    </div>

  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Проведение экспертизы промышленной безопасности
    </h1>
    <ul class="link-arrow">
      <li>- В Москве и в регионах</li>
      <li>- Опытные эксперты</li>
      <li>- Собственная ЛНК</li>
      <li>- Все объекты экспертизы промышленной безопасности</li>
      <li>- Полное соответствие требованиям и соблюдение заявленных сроков</li>
    </ul>

    <p class="mt-4">Экспертиза промбезопасности проводится в соответствии с <strong>Федеральным законом от 21.07.1997 № 116-ФЗ &quot;О промышленной безопасности опасных производственных объектов&quot;, а также в соответствии с Федеральными нормами и правилами </strong>в отношении зданий, сооружений и технических устройств, применяемых на ОПО, содержащими утвержденный порядок проведения, требования и нормы.</p>

    <h2>В каких случаях проводится эпб:</h2>

    <ul class="marked ml-50">
      <li>Перед вводом в эксплуатацию технических устройств, зданий и сооружений;</li>
      <li>По окончании срока эксплуатации ТУ или в случае отсутствия нормативных документов (паспорта, инструкции) с указанным сроком службы или таковых сведений в них;</li>
      <li>После осуществления восстановительных ремонтных работ.</li>
    </ul>

    <p>Результаты эпб отражаются в соответствующем заключении, подлежащем последующей регистрации в государственном реестре. Эксплуатация устройств без положительного заключения эпб не допускается.</p>

    <p style="border:none; margin-top:0pt; margin-bottom:0pt">Для внесения сведений в реестр - в Ростехнадзор необходимо предоставить заявление, подписанное руководителем эксплуатирующей организации и заключение ЭПБ, заверенное печатью и подписью руководителя и экспертов организации, проводившей данную экспертизу.</p>
    <app-atomka-calc class="w-100" heading="Получить консультацию и предварительный расчет стоимости экспертизы промышленной безопасности"></app-atomka-calc>
    <h2>Специалисты ООО &laquo;Протос&nbsp; Экспертиза&raquo;:</h2>

    <ul class="marked ml-50">
      <li>Проведут экспертизу промышленной безопасности, в том числе повторную экспертизу или эпб на вновь введенный объект&nbsp;в соответствии с Федеральными нормами и правилами и полным соблюдением указанных в договоре сроков.</li>
      <li>Подготовят заключение экспертизы промышленной безопасности;</li>
      <li>Внесут необходимые сведения в реестр ЭПБ Ростехнадзора;</li>
      <li>Дадут разъяснения по каждому этапу.</li>
    </ul>

    <p>Стоимость рассчитывается индивидуально. Для получения окончательного расчета свяжитесь со специалистом нашей компании.</p>
    <div class="yellow-block w-100 mt-5">
      <h2 style="margin-top: 0">Мы проводим экспертизу промышленной безопасности:</h2>

      <ul class="marked ml-50">
        <li>технических устройств (ЭПБ ТУ)</li>
        <li>зданий и сооружений (ЭПБ ЗС)</li>
        <li>документации на техническое перевооружение (ТП)</li>
        <li>документации на консервацию, ликвидацию ОПО (КЛ)</li>
      </ul>

    </div>
    <app-recall-form heading="Оставьте заявку и наши специалисты Вас проконсультируют"></app-recall-form>
    <div>
      <h2>Что включает в себя экспертиза промышленной безопасности</h2>

      <p><strong>Экспертиза промышленной безопасности</strong> организации проводится с целью экспертной оценки соответствия объекта требованиям промышленной безопасности и включает в себя:</p>

      <p>I.<strong>&nbsp;ЭПБ технических устройств,</strong> применяемых на опасном производственном объекте.</p>
    </div>

    <p>II.<strong> ЭПБ зданий и сооружений</strong> на опасном производственном объекте, предназначенных для осуществления технологических процессов, хранения сырья или продукции, перемещения людей и грузов, локализации и ликвидации последствий аварий.</p>

    <p>III<strong>. Экспертизу документации</strong>: на консервацию, ликвидацию и техническое перевооружение опасного производственного объекта;</p>

    <p>Данная процедура позволяет оценить фактическое состояние зданий, сооружений, технических устройств и сделать соответствующие выводы о достоверности и соответствии их документации. Экспертиза пб проводится организациями, имеющими действующую лицензию Ростехнадзора, подтверждающую право экспертных организаций на проведение указанной экспертизы.</p>
    <div class="mt-5 row">
      <div class="col">
        <img src="assets/img_28.png" height="880" alt="" style="width: 100%">
        <p class="text-center">Лицензия ООО "Протос Экспертиза"</p>
      </div>
      <div class="col">
        <img src="assets/img_29.png" height="880" style="width: 100%;" alt="">
        <p class="text-center">Свидетельство об аттестации ЛНК</p>

      </div>
    </div>
    <p><strong>Специалисты ООО &laquo;Протос Экспертиза&raquo; работают в области промышленной безопасности более 20 лет. Опыт, квалификация и собственная лаборатория неразрушающего контроля позволяют нам проводить экспертизу промышленной безопасности любых ОПО с полным соблюдением законодательства и заявленных сроков. Стоимость рассчитывается индивидуально. </strong></p>
    <app-recall-form heading="У вас есть вопросы? Наши специалисты вас проконсультируют"></app-recall-form>
    <h2>Прохождение и порядок проведения экспертизы промышленной безопасности.</h2>

    <p><strong>Порядок проведения экспертизы промышленной безопасности регламентируется Федеральными нормами и правилами в области промышленной безопасности &quot;Правила проведения экспертизы промышленной безопасности&quot;:</strong></p>
    <div id="accordion">
      <div class="card mt-4">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button class="btn btn-link accordion-button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              1-й этап - проведение экспертизы промышленной безопасности:
            </button>
          </h5>
        </div>

        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
            <div class="container-lg">
              <div class="callout callout-danger">
                <p><font size="+0">а) заключение соответствующего договора на получение экспертизы промышленной безопасности, предоставление заказчиком в соответствии с договором необходимых для проведения экспертизы документов, предоставление заказчиком образцов технических устройств либо обеспечения доступа экспертов к техническим устройствам, зданиям и сооружениям, применяемым на опасном производственном объекте.</font></p>

                <p><font size="+0">б) определение приказом руководителя организации, проводящей экспертизу промышленной безопасности, эксперта или группы экспертов, участвующих в проведении экспертизы, руководителя соответствующей группы.</font></p>

                <ul class="marked ml-50">
                  <li><font size="+0">В состав группы экспертов могут быть включены эксперты, не состоящие в штате экспертной организации, если их специальные знания необходимы для проведения экспертизы и такие эксперты отсутствуют в экспертной организации.</font></li>
                  <li><font size="+0">В проведении экспертизы в отношении опасных производственных объектов I класса опасности вправе участвовать эксперты первой категории.</font></li>
                  <li><font size="+0">В проведении экспертизы в отношении опасных производственных объектов II класса опасности вправе участвовать эксперты первой и (или) второй категории.</font></li>
                  <li><font size="+0">В проведении экспертизы в отношении опасных производственных объектов III и IV классов опасности вправе участвовать эксперты первой и (или) второй, и (или) третьей категории.</font></li>
                </ul>

                <p><font size="+0">в) проведение экспертизы промышленной безопасности.</font></p>

                <p><font size="+0">При проведении экспертизы промышленной безопасности проводятся следующие мероприятия:</font></p>

                <ul class="marked ml-50">
                  <li><font size="+0">устанавливается полнота и достоверность относящихся к объекту экспертизы документов, предоставленных заказчиком;</font></li>
                  <li><font size="+0">оценивается фактическое состояние технических устройств, зданий и сооружений на опасных производственных объектах (обследование зданий, сооружений, техническое диагностирование, неразрушающий и разрушающий контроль технических устройств);</font></li>
                </ul>

                <p><font size="+0">Техническое диагностирование, неразрушающий контроль или разрушающий контроль технических устройств проводится для оценки фактического состояния технических устройств в следующих случаях:</font></p>

                <ul class="marked ml-50">
                  <li><font size="+0">при проведении экспертизы по истечении срока службы или при превышении количества циклов нагрузки такого технического устройства, установленных его производителем, либо при отсутствии в технической документации данных о сроке службы такого технического устройства, если фактический срок его службы превышает двадцать лет;</font></li>
                  <li><font size="+0">при проведении экспертизы после проведения восстановительного ремонта после аварии или инцидента на опасном производственном объекте, в результате которых было повреждено такое техническое устройство;</font></li>
                  <li><font size="+0">при обнаружении экспертами в процессе осмотра технического устройства дефектов, вызывающих сомнение в прочности конструкции, или дефектов, причину которых установить затруднительно;</font></li>
                  <li><font size="+0">в иных случаях, определяемых руководителем организации, проводящей экспертизу.</font></li>
                </ul>

                <p><font size="+0">Экспертная организация вправе привлекать к проведению технического диагностирования, неразрушающего контроля, разрушающего контроля технических устройств, а также к проведению обследований зданий и сооружений иные организации или лиц, владеющих необходимым оборудованием для проведения указанных работ.</font></p>

                <p><font size="+0">Ответственность за качество и результаты работы привлекаемых организаций и лиц несет руководитель организации, проводящей экспертизу.</font></p>

                <p><font size="+0">По результатам проведения технического диагностирования, неразрушающего контроля, разрушающего контроля технических устройств, обследования зданий и сооружений составляется акт о проведении указанных работ.</font></p>

                <p><font size="+0">Срок проведения экспертизы определяется сложностью объекта экспертизы, но не должен превышать трех месяцев с момента получения экспертной организацией от заказчика экспертизы комплекта необходимых материалов и документов в соответствии с договором на проведение экспертизы.</font></p>

                <p><font size="+0">г) оформление результата проведения экспертизы промышленной безопасности.</font></p>              </div></div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0">
            <button class="btn btn-link accordion-button collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              2-й этап - представление заключения экспертизы промышленной безопасности в Ростехнадзор (его территориальный орган) для внесения его в реестр заключений экспертизы промышленной безопасности.
            </button>
          </h5>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
          <div class="card-body">
            <div class="container-lg">
              <div class="callout callout-danger">
                Заключение экспертизы промышленной безопасности представляется в Ростехнадзор (его территориальный орган), который вносит в реестр заключений экспертизы промышленной безопасности это заключение в течение пяти рабочих дней со дня его поступления.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0">
            <button class="btn btn-link accordion-button collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              3-й этап - внесение заключения экспертизы промышленной безопасности в соответствующий реестр.
            </button>
          </h5>
        </div>
        <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordion">
          <div class="card-body"><div class="container-lg">
            <div class="callout callout-danger">

            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <app-recall-form heading="Нет времени изучать детали? Наши специалисты вас проконсультируют"></app-recall-form>

    <app-reviews-block class="w-100"></app-reviews-block>
  </div>
</div>
<app-footer></app-footer>
